import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../translations';

function Impressum() {
  const { lang } = useLanguage();

  return (
    <>
      <section className="page-hero">
        <h1><span className="gradient-text">{t(lang, 'impressum_title')}</span></h1>
      </section>

      <section className="section">
        <div className="container impressum-content">
          <h2>{t(lang, 'impressum_tmg')}</h2>
          <p>
            Red-Database-Security GmbH<br />
            Eibenweg 42<br />
            D-63150 Heusenstamm
          </p>

          <h2>{t(lang, 'impressum_represented')}</h2>
          <p>Geschäftsführer: Alexander Kornbrust</p>

          <h2>{t(lang, 'impressum_contact')}</h2>
          <p>
            {t(lang, 'contact_phone')}: +49 (0)6821 – 95 17 637<br />
            {t(lang, 'contact_fax')}: +49 (0)6821 – 91 27 354<br />
            {t(lang, 'contact_email')}: info@red-database-security.com
          </p>

          <h2>{t(lang, 'impressum_register')}</h2>
          <p>
            Amtsgericht Offenbach am Main<br />
            HRB 47864
          </p>

          <h2>{t(lang, 'impressum_vat')}</h2>
          <p>
            {t(lang, 'impressum_vat_text')}<br />
            DE814110031
          </p>

          <h2>{t(lang, 'impressum_responsible')}</h2>
          <p>Alexander Kornbrust</p>

          <h2>{t(lang, 'impressum_disclaimer')}</h2>

          <h2>{t(lang, 'impressum_content_title')}</h2>
          <p>{t(lang, 'impressum_content_text')}</p>

          <h2>{t(lang, 'impressum_links_title')}</h2>
          <p>{t(lang, 'impressum_links_text')}</p>

          <h2>{t(lang, 'impressum_copyright_title')}</h2>
          <p>{t(lang, 'impressum_copyright_text')}</p>
        </div>
      </section>
    </>
  );
}

export default Impressum;
